<template>
    <div class="input_native">
        <div v-if="v.$error" class="red-text">{{ $t("Пароль должен содержать 10 символов, строчные и прописные буквы латинского алфавита, спецсимволы.") }}</div>
        <div v-if="v.$params.confirm_pass && !v.confirm_pass" class="red-text">{{ $t("Подтверждение пароля не совпадает") }}</div>
        <input v-model.trim="password" v-bind="$attrs" class="input"
               :class="invalid" type="password" :placeholder="$t('Введите пароль')"
               @input="$emit('change', $event)"
        >
    </div>
</template>

<script>
export default {
  props: {
    value: {
      type   : String,
      default: '',
    },
    v: {
      type    : Object,
      required: true,
    },
  },
  computed: {
    invalid() {
      console.log(this.v);
      return this.v.$error ? 'form__error' : '';
    },
    password: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {

  },
};
</script>
